import theme from 'config/theme';
import {Button} from 'interface/base/Button';
import {Icon} from 'interface/base/Icon';
import {Tooltip} from 'interface/base/Tooltip';
import {PLACEMENT} from 'interface/base/Tooltip/consts';
import {StyleSheet} from 'react-native';

type Props = {
  iconName: string;
  onPress: () => void;
  tooltipText?: string;
};

export function AiChatMenuButton({iconName, onPress, tooltipText}: Props) {
  return (
    <Tooltip placement={PLACEMENT['bottom-start']} content={tooltipText}>
      <Button
        overrides={{
          Button: {
            style: styles.button,
          },
        }}
        variant="text"
        onPress={onPress}
        startEnhancer={
          <Icon name={iconName} color={theme.colors.neutral.$700} />
        }
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
